export const NAME = 'multiPageHandGathering';